export const VERIFY_CONTEXT = "verify-api";

export const VERIFY_SERVER = `https://dev-cross-verify.cross-nexus.com`;
export const VERIFY_SERVER_V3 = `${VERIFY_SERVER}`;

export const TRUSTED_VERIFY_URLS = [VERIFY_SERVER];
